export const colorCoreO3 = "#fc5200"; // strava-orange
export const colorCoreAsphalt = "#000000"; // black
export const colorCoreN6 = "#f3f2ed"; // sand
export const colorCoreN7 = "#f9f8f5"; // light-sand
export const colorCoreWhite = "#ffffff";
export const colorSecondaryB1 = "#002e51"; // dark-blue
export const colorSecondaryT2 = "#276268"; // dark-teal
export const colorSecondaryG1 = "#4a5328"; // dark-green
export const colorSecondaryY2 = "#deaa45"; // gold
export const colorSecondaryG5 = "#c0ca53"; // lime
export const colorSecondaryO6 = "#fed4bf"; // peach
export const colorSecondaryP5 = "#ffa6eb"; // pink
export const colorSecondaryY5 = "#f2f343"; // yellow
export const colorSecondaryT5 = "#78dae5"; // teal
export const colorAchievementsY2 = "#deaa45"; // first place
export const colorAchievementsSilver = "#9c9c9c"; // second place
export const colorAchievementsBronze = "#d88322"; // third place
export const colorExtendedBlueB1 = "#002e51"; // dark-blue
export const colorExtendedBlueB2 = "#004a80";
export const colorExtendedBlueB3 = "#1274bc";
export const colorExtendedBlueB4 = "#3fa3eb";
export const colorExtendedBlueB5 = "#75baed";
export const colorExtendedBlueB6 = "#aed8f7";
export const colorExtendedTealT1 = "#0d4045";
export const colorExtendedTealT2 = "#276268"; // dark-teal
export const colorExtendedTealT3 = "#1d8b96";
export const colorExtendedTealT4 = "#44b6c2";
export const colorExtendedTealT5 = "#78dae5"; // teal
export const colorExtendedTealT6 = "#baeff5";
export const colorExtendedGreenG1 = "#4a5328"; // dark-green
export const colorExtendedGreenG2 = "#547200";
export const colorExtendedGreenG3 = "#79a300";
export const colorExtendedGreenG4 = "#9bb628";
export const colorExtendedGreenG5 = "#c0ca53"; // lime
export const colorExtendedGreenG6 = "#e5ed88";
export const colorExtendedRedR1 = "#930202";
export const colorExtendedRedR2 = "#c50505"; // error-red
export const colorExtendedRedR3 = "#e51919";
export const colorExtendedRedR4 = "#ff6565";
export const colorExtendedRedR5 = "#ff9999";
export const colorExtendedRedR6 = "#ffc5c5";
export const colorExtendedPinkP1 = "#8d0277";
export const colorExtendedPinkP2 = "#b20797";
export const colorExtendedPinkP3 = "#df40bb";
export const colorExtendedPinkP4 = "#fc6ddb";
export const colorExtendedPinkP5 = "#ffa6eb"; // pink
export const colorExtendedPinkP6 = "#ffc7f2";
export const colorExtendedYellowY1 = "#b7831d";
export const colorExtendedYellowY2 = "#deaa45"; // gold
export const colorExtendedYellowY3 = "#e5c145";
export const colorExtendedYellowY4 = "#ebd944";
export const colorExtendedYellowY5 = "#f2f343"; // yellow
export const colorExtendedYellowY6 = "#fbfc90";
export const colorExtendedOrangeO1 = "#c02e00";
export const colorExtendedOrangeO2 = "#da3400";
export const colorExtendedOrangeO3 = "#fc5200"; // strava-orange
export const colorExtendedOrangeO4 = "#ff7e40";
export const colorExtendedOrangeO5 = "#ffac84";
export const colorExtendedOrangeO6 = "#fed4bf"; // peach
export const colorExtendedNeutralN1 = "#2b2b2b";
export const colorExtendedNeutralN2 = "#525252";
export const colorExtendedNeutralN3 = "#808080";
export const colorExtendedNeutralN4 = "#aba9a5";
export const colorExtendedNeutralN5 = "#d3d1cd";
export const colorExtendedNeutralN6 = "#f3f2ed"; // sand
export const colorExtendedNeutralN7 = "#f9f8f5"; // ligh-sand
export const colorLegacyOrangeO60Rust = "#cc4200";
export const colorLegacyOrangeO50StravaOrange = "#fc5200";
export const colorLegacyOrangeO40Pumpkin = "#fc6100";
export const colorLegacyNeutralN90Coal = "#242428";
export const colorLegacyNeutralN80Asphalt = "#494950";
export const colorLegacyNeutralN70Gravel = "#6d6d78";
export const colorLegacyNeutralN40Steel = "#b2afc0";
export const colorLegacyNeutralN30Silver = "#dfdfe8";
export const colorLegacyNeutralN20Icicle = "#f0f0f5";
export const colorLegacyNeutralN10Fog = "#f7f7fa";
export const colorLegacyRedR50Red = "#db0014";
export const colorLegacyYellowY50Gold = "#fdc746";
